import { render, staticRenderFns } from "./ItemClassSelector.vue?vue&type=template&id=323dbb8e&scoped=true&"
import script from "./ItemClassSelector.vue?vue&type=script&lang=ts&"
export * from "./ItemClassSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ItemClassSelector.vue?vue&type=style&index=0&id=323dbb8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323dbb8e",
  null
  
)

export default component.exports